import { useCart } from "@shopify/hydrogen";

function useCartBadge() {
  const { totalQuantity } = useCart();

  return {
    models: {
      totalQuantity,
    },
  };
}

export function CartBadge({className}) {
  const { models } = useCartBadge();

  if (models.totalQuantity < 1) {
    return null;
  }

  return (
   
      <p className="pl-2"> {models.totalQuantity}</p>

  );
}
